import { apiUrl } from "../../config/base.js";
import axios from 'axios';

export default {
	add(email) {
		return axios.post(apiUrl + '/admin/unsubscribers/store', { email: email });
	},
	uploadEmailList(requestPayload) {
		return axios.post(apiUrl + '/admin/unsubscribers/uploadEmailList', requestPayload, {
			headers: {
				'content-type': 'multipart/form-data'
			}
		});
	},
	delete(unsubscriberId) {
		return axios.delete(apiUrl + '/admin/unsubscribers/' + unsubscriberId + '/delete');
	},
	getFilteredUnsubscribers(searchedEmail) {
		return axios.post(apiUrl + '/admin/unsubscribers/getFilteredUnsubscribers', { searchedEmail: searchedEmail });
	} 
}

